import { CommonModule } from '@angular/common';
// Angular modules
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgSelectModule } from '@ng-select/ng-select';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';

import { DragDropModule } from '@angular/cdk/drag-drop';


import { GridModule, FilterService } from '@progress/kendo-angular-grid';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { PopupModule } from '@progress/kendo-angular-popup';

// kendo localization languages support
import { IntlModule } from '@progress/kendo-angular-intl';
import '@progress/kendo-angular-intl/locales/bg/all';
import '@progress/kendo-angular-intl/locales/hr/all';
import '@progress/kendo-angular-intl/locales/cs/all';
import '@progress/kendo-angular-intl/locales/da/all';
import '@progress/kendo-angular-intl/locales/nl/all';
import '@progress/kendo-angular-intl/locales/et/all';
import '@progress/kendo-angular-intl/locales/fi/all';
import '@progress/kendo-angular-intl/locales/fr/all';
import '@progress/kendo-angular-intl/locales/de/all';
import '@progress/kendo-angular-intl/locales/el/all';
import '@progress/kendo-angular-intl/locales/hu/all';
import '@progress/kendo-angular-intl/locales/ga/all';
import '@progress/kendo-angular-intl/locales/it/all';
import '@progress/kendo-angular-intl/locales/lv/all';
import '@progress/kendo-angular-intl/locales/lt/all';
import '@progress/kendo-angular-intl/locales/mt/all';
import '@progress/kendo-angular-intl/locales/pl/all';
import '@progress/kendo-angular-intl/locales/pt/all';
import '@progress/kendo-angular-intl/locales/ro/all';
import '@progress/kendo-angular-intl/locales/sk/all';
import '@progress/kendo-angular-intl/locales/sl/all';
import '@progress/kendo-angular-intl/locales/es/all';
import '@progress/kendo-angular-intl/locales/sv/all';
import { TranslateModule } from '@ngx-translate/core';

import { ToastrModule } from 'ngx-toastr';
import { I18nDateTime24HPipe } from './i18n/datetime24h.pipe';
import { I18nDatePipe } from './i18n/date.pipe';
import { AttributeValuesTreeContainerComponent } from './tree-view/containers/Attribute-values-tree/attribute-values-tree-container.component';
import { AttrValueSelectionTreeDialogComponent } from './attr-value-selection-tree-dialog/attr-value-selection-tree-dialog.component';
import { TreeViewComponent } from './tree-view/tree-view.component';
import { AppVirtualTreeComponent } from './tree-view/virtual-tree/virtual-tree.component';

@NgModule({
  declarations: [
    I18nDateTime24HPipe,
    I18nDatePipe,
    TreeViewComponent,
    AttributeValuesTreeContainerComponent,
    AttrValueSelectionTreeDialogComponent,
    AppVirtualTreeComponent
  ],
  imports: [

    // Angular
    CommonModule,
    TranslateModule,
    DragDropModule,

    // Material
    MatFormFieldModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDatepickerModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatTooltipModule,
    MatChipsModule,
    MatIconModule,
    MatButtonToggleModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatButtonModule,

    // Kendo
    TreeViewModule,
    PopupModule,
    IntlModule,
    GridModule,

    // Toastr
    ToastrModule.forRoot({
      timeOut: 7000,
      positionClass: 'toast-bottom-full-width',
      closeButton: true,
      enableHtml: true,
      preventDuplicates: true
    }),
  ],
  exports: [
    // Components
    TreeViewComponent,
    AttributeValuesTreeContainerComponent,
    AttrValueSelectionTreeDialogComponent,
    AppVirtualTreeComponent,

    NgSelectModule,

    // Modules Angular
    FormsModule,
    ReactiveFormsModule,

    // Modules Material
    MatFormFieldModule,
    MatCheckboxModule,
    MatDialogModule,
    MatInputModule,
    MatTooltipModule,
    MatChipsModule,
    MatIconModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatButtonModule,

    // Modules Kendo
    TreeViewModule,
    PopupModule,
    IntlModule,
    GridModule,

    // Module
    I18nDateTime24HPipe,
    I18nDatePipe
  ],
  entryComponents: [
    AttrValueSelectionTreeDialogComponent
  ],
  providers: [
    FilterService
  ]
})
export class SharedModule {
}
